export enum WebsocketMessageType {
  LIST_ROOMS = 'LIST_ROOMS',
  PLAYER_LIST = 'PLAYER_LIST',
  USER_DETAILS = 'USER_DETAILS',
  USER_UPDATE = 'USER_UPDATE',
  LIST_ROOMS_RESPONSE = 'LIST_ROOMS_RESPONSE',
  CHAT_MSG = 'CHAT_MSG',
  USER_ADDED = 'USER_ADDED',
  USER_REMOVED = 'USER_REMOVED',
  ENTER_ROOM = 'ENTER_ROOM',
  ENTER_ROOM_CONFIRM = 'ENTER_ROOM_CONFIRM',
  EXIT_ROOM = 'EXIT_ROOM',
  NEW_GAME = 'NEW_GAME',
  ACCEPT_GAME = 'ACCEPT_GAME',
  LIST_PLAYERS_MESSAGE = 'LIST_PLAYERS_MESSAGE',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  NEW_GAME_INVITE = 'NEW_GAME_INVITE',
  INVITE_STATUS = 'INVITE_STATUS',
  GAME_REMOVED = 'GAME_REMOVED',
  GAME_ADDED = 'GAME_ADDED',
  HIT_POWER = 'HIT_POWER',
  CUE_POSITION = 'CUE_POSITION',
  HIT_POINT = 'HIT_POINT',
  HIT_DIRECTION = 'HIT_DIRECTION',
  HIT_CUE_BALL = 'HIT_CUE_BALL',
  HIT_RESULT = 'HIT_RESULT',
  START_GAME = 'START_GAME',
  LEAVE_GAME = 'LEAVE_GAME',
  DISCARD_GAME = 'DISCARD_GAME',
  GAME_USER_ADDED = 'GAME_USER_ADDED',
  GAME_USER_REMOVED = 'GAME_USER_REMOVED',
  WATCH_GAME = 'WATCH_GAME',
  GAME_STATE = 'GAME_STATE',
  EXIT_GAME = 'EXIT_GAME',
  GAME_MESSAGE = 'GAME_MESSAGE',
  PASS_BACK = 'PASS_BACK',
  TOURNAMNET_INVITE = 'TOURNAMNET_INVITE',
  TOURNAMNET_SIGNUP = 'TOURNAMNET_SIGNUP',
  TOURNAMNET_SIGNUP_RESULT = 'TOURNAMNET_SIGNUP_RESULT',
  MATCH_END = 'MATCH_END',
  GAME_END = 'GAME_END',
  USER_CREDIT_UPDATE = 'USER_CREDIT_UPDATE',
  USER_UPDATE_DISPLAY_NAME = 'USER_UPDATE_DISPLAY_NAME',
  LEAGUE_GAME_MESSAGE = 'LEAGUE_GAME_MESSAGE',
  TOURNAMENT_GAME_MESSAGE = 'TOURNAMENT_GAME_MESSAGE',
  TOURNAMENT_ACCEPT = 'TOURNAMENT_ACCEPT',
  TOURNAMENT_ACCEPT_RESULT = 'TOURNAMENT_ACCEPT_RESULT',
  ROOM_COUNT_MESSAGE = 'ROOM_COUNT_MESSAGE',
  SYNCHRONIZE_GAME = 'SYNCHRONIZE_GAME',
}
